export class AtClass {
    constructor() {
        this.id = 0;
        this.atname = "";
    }
}